import React, { useEffect, useState } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { getCategory } from "../../../../Redux/App/action";
import { Link } from "react-router-dom";
import "./shop.css";
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ShopCarousel = () => {
  const dispatch = useDispatch();

  const { category } = useSelector((store) => store.appReducer);

  const getCategoryRoute = (categoryName) => {
    switch (categoryName) {
      case "Pots":
        return "/potsAll";
      case "Plants":
        return "/plantEcommerce";
      case "Home-Decor":
        return "/homeDecorAll";
      case "Cakes":
      case "Chocolate":
        return "/inspirationCategory";
      case "Photo-Frames":
        return "/photoFrames";
      default:
        return "/";
    }
  };

  useEffect(() => {
    dispatch(getCategory);
  }, [dispatch]);
  return (
    <>
      <Box w="100%" display={{ md: "none", base: "block" }}>
        <Carousel responsive={responsive} className="carousel-container">
          {category &&
            category.map((el, i) => (
              <Link key={i} to={getCategoryRoute(el.categoryName)}>
                <Image
                  src={el.imageUrl}
                  w={{ md: "98%", base: "98%" }}
                  mr={{ base: "0", md: "14px" }}
                />
              </Link>
            ))}
        </Carousel>
      </Box>
      <Flex
        w="100%"
        justifyContent={"space-between"}
        gap={5}
        display={{ md: "flex", base: "none" }}
      >
        {category &&
          category.map((el, i) => (
            <Link key={i} to={getCategoryRoute(el.categoryName)}>
              <Image src={el.imageUrl} w={{ md: "100%", base: "98%" }} />
            </Link>
          ))}
      </Flex>
    </>
  );
};

export default ShopCarousel;
